import React from 'react'
import Link from 'gatsby-link'
import AttnLogo from './attn-logo'
import SocialLinks from './social-links-new'

const Footer = () => {
  const now = new Date()
  const copyright = `\u00a9 ${now.getFullYear()} ATTN:, Inc.`

  return (
    <footer className='footer-new'>
      <div className='wrapper--max-width'>
        <div className='footer__logo'>
          <AttnLogo />
          <p className='footer__address'>
            5700 Wilshire Blvd Suite 375<br />Los Angeles, CA 90036
          </p>
        </div>
        <div className='footer__links'>
          <SocialLinks />
          <div className='footer__navigation'>
            <Link to='/press' className='footer__link'>Press</Link>
            <Link to='/careers' className='footer__link'>Careers</Link>
            <Link to='/contact' className='footer__link'>Contact</Link>
          </div>
          <div className='footer__navigation--extra'>
            <Link to='/terms' className='footer__link'>Terms of Use</Link>
            <Link to='/privacy' className='footer__link'>Privacy Policy</Link>
          </div>
        </div>
      </div>
      <div className='footer__candle'>
        <div className='footer__copyright'>
          <span>{copyright}</span>
        </div>
        <div className='footer__candle-items'>
          <span className='footer__candle-slogan'>we see a bright future.</span>
          <span className='footer__candle-logo'>
            <img src='/img/Candle_Logo_Alpha_01.png' alt='Candle logo' />
          </span>
        </div>
      </div>
    </footer>
  )
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/footer-new.js